<template>
  <div class="container_self">
    <el-row class="add_btn"
      ><el-button type="primary" icon="el-icon-plus" size="mini" @click="addUrl"
        >新增链接</el-button
      ></el-row
    >
    <h3>中间链接列表</h3>
    <el-row class="table_parent">
      <el-table :data="ulrList">
        <el-table-column label="ID" width="50" prop="id" align="center"></el-table-column>
        <el-table-column
          label="所属客户"
          prop="customerName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="主域名"
          prop="mainDomain"
          align="center"
        ></el-table-column>
        <el-table-column label="子域名" prop="subDomain" align="center"></el-table-column>
        <el-table-column
          label="语言"
          prop="lang"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column label="链接" prop="link" align="center"></el-table-column>
        <el-table-column label="是否启用" prop="enabled" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.enabled">启用</span>
            <span v-else>未启用</span>
          </template>
        </el-table-column>
        <el-table-column label="描述" prop="description" align="center"></el-table-column>
        <el-table-column
          label="更新时间"
          prop="updateTime"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="updateUrl(scope.row)"
              >更新</el-button
            >
            <el-button size="mini" type="danger" @click="deleteUrl(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-row>
    <el-dialog
      :title="string + '中间链接'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        :model="addUrlForm"
        label-width="120px"
        :rules="rules"
        ref="ruleForm"
        size="mini"
        class="demo-ruleForm"
      >
        <el-form-item label="所属客户" prop="customerId">
          <el-select
            v-model="addUrlForm.customerId"
            remote
            reserve-keyword
            filterable
            placeholder="请输入关键词"
            :remote-method="searchPackage"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="enabled">
          <el-select v-model="addUrlForm.enabled">
            <el-option :value="1" label="启用"></el-option>
            <el-option :value="0" label="未启用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="语言" prop="lang">
          <el-select v-model="addUrlForm.lang" filterable placeholder="请输入国家/地区">
            <el-option
              v-for="(item, index) in langs"
              :value="item.lang"
              :label="item.label"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主域名" prop="mainDomain">
          <el-input placeholder="请输入主域名" v-model="addUrlForm.mainDomain"></el-input>
        </el-form-item>
        <el-form-item label="子域名" prop="subDomain">
          <el-input placeholder="请输入子域名" v-model="addUrlForm.subDomain"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="link">
          <el-input placeholder="请输入链接" v-model="addUrlForm.link"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input placeholder="请输入描述" v-model="addUrlForm.description"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      ulrList: [],
      searchForm: {
        customerId: "",
        enabled: "", //是否启用
        endTime: "",
        startTime: "",
        lang: "", //语言
        mainDomain: "", //主域名
        subDomain: "", //子域名
        currentPage: 1,
        pageSize: 10,
      },
      total: 0,
      addUrlForm: {
        customerId: 1,
        description: "",
        enabled: 1,
        id: 0,
        lang: "zh-CN",
        link: "",
        mainDomain: "",
        subDomain: "",
      },
      string: "新增",
      dialogFormVisible: false,
      rules: {
        customerId: [{ required: true, message: "请先选择客户", trigger: "blur" }],
        enabled: [{ required: true, message: "请先选择是否启用", trigger: "blur" }],
        lang: [{ required: true, message: "请先选择语言", trigger: "blur" }],
        link: [{ required: true, message: "请先输入链接", trigger: "blur" }],
        mainDomain: [{ required: true, message: "请先输主域名", trigger: "blur" }],
        subDomain: [{ required: true, message: "请先输子域名", trigger: "blur" }],
      },
      options: [],
      langs: require("@/assets/langs.json"),
    };
  },
  methods: {
    getList(params) {
      axiosGet("/api/middle_link/list", params).then((res) => {
        if (res.code == 0) {
          this.ulrList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    async updateUrl(row) {
      this.addUrlForm = {
        customerId: row.customerId,
        description: row.description || "",
        enabled: row.enabled,
        id: row.id,
        lang: row.lang,
        link: row.link,
        mainDomain: row.mainDomain,
        subDomain: row.subDomain,
      };
      await this.getCustomList({
        keyword: row.customerName,
        currentPage: 1,
        pageSize: 10,
      });
      this.string = "更新";
      this.dialogFormVisible = true;
    },
    resetForm() {
      this.dialogFormVisible = false;
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields(); // 重置表单验证
      }
    },
    addUrl() {
      this.addUrlForm = {
        description: "",
        enabled: 1,
        id: 0,
        lang: "en",
        link: "",
        mainDomain: "",
        subDomain: "",
      };
      this.string = "新增";
      this.dialogFormVisible = true;
    },
    deleteUrl(row) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosPost("/api/middle_link/delete", { id: row.id }, "JSON").then((res) => {
            if (res.code == 0) {
              this.$message({ message: "删除成功", type: "success" });
              this.getList(this.searchForm);
            }
          });
        })
        .catch(() => {});
    },
    searchPackage(keyword) {
      if (keyword) {
        this.getCustomList({ currentPage: 1, pageSize: 20, keyword: keyword });
      }
    },
    async submitForm(formName) {
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
      if (valid) {
        let url =
          this.string === "更新" ? "/api/middle_link/update" : "/api/middle_link/add";
        await axiosPost(url, this.addUrlForm, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: this.string + "成功", type: "success" });
          }
        });
        this.getList(this.searchForm);
        this.dialogFormVisible = false;
      }
    },
    async getCustomList(params) {
      await axiosGet(
        "/api/customer/list?currentPage=" +
          params.currentPage +
          "&pageSize=" +
          params.pageSize +
          "&keyword=" +
          params.keyword
      ).then((res) => {
        if (res.code == 0) {
          this.options = res.data.records;
        }
      });
    },
    handleSizeChange(val) {
      // console.log(val);
      this.searchForm.pageSize = val;
      this.searchForm.currentPage = 1;
      this.getList(this.searchForm);
    },
    handleCurrentChange(val) {
      // this.searchForm.pageSize=val;
      this.searchForm.currentPage = val;
      this.getList(this.searchForm);
    },
  },
  mounted() {
    this.getList(this.searchForm);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/middleware.vue